import * as types from '../mutation-types'

const state = {
  pageSize: 100,  // リスト取得時の1ページのサイズ
  pageSizes: [1, 2, 3, 10, 100],
}

const mutations = {
  [types.SET_PAGE_SIZE] (state, data) {
    state.pageSize = data
  },
}

const actions = {
  setPageSize ({commit}, data) {
    commit(types.SET_PAGE_SIZE, data)
  },
}

const getters = {
  pageSize: state => state.pageSize,
  pageSizes: state => state.pageSizes,
}

export default {
  actions,
  getters,
  mutations,
  state,
  namespaced: true,
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js